export default "__VITE_ASSET__263158b9__"